import Request from "../utils/request";

import { ipUrl } from "./index";

/**********************************订单管理******************************************** */

//前台新增订单
export function orderAdd(data) {
  return Request({
    url: `${ipUrl}order/add`,
    method: "post",
    data: data,
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}

//条件查询
export function findSelect(data) {
  return Request({
    url: `${ipUrl}order/findSelect`,
    method: "post",
    data: data,
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}

//导出功能
export function exportXls(username) {
  return Request({
    url: `${ipUrl}order/exportXls?username=${username}`,
    method: "get",
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}



// WEBPACK FOOTER //
// ./src/service3/orderController.js